import { z } from 'zod';
import { botScopeSchema, uuidV7Schema } from './ids';

export const usageArchiveJobSchema = z
  .object({
    type: z.literal('usage_archive'),
    eventId: uuidV7Schema,
    scope: botScopeSchema,
    conversationId: uuidV7Schema,
    occurredAt: z.iso.datetime({ offset: true }),
    model: z.string().trim().min(1).max(100),
    operation: z.enum(['classifier', 'response', 'embedding', 'tool']),
    inputTokens: z.number().int().nonnegative(),
    cachedInputTokens: z.number().int().nonnegative(),
    cacheWriteTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    providerCostMicroUsd: z.string().regex(/^\d+$/u),
  })
  .strict();

export type UsageArchiveJob = z.infer<typeof usageArchiveJobSchema>;
